<template>
  <!-- 员工照片采集页 -->
  <div class="faceCollection">
    <van-nav-bar
      :title="$t('faceCollection.FcText1')"
      left-text
      left-arrow
      @click-left="onClickLeft"
    >
      <template #right>
        <van-tag
          v-if="otherUserName"
          closeable
          size="medium"
          type="success"
          @close="closeOtherEmp"
        >
          {{ otherUserName }}
        </van-tag>
        <van-icon
          v-if="can_query_branch_record"
          name="friends-o"
          size="18"
          color="#ffffff"
          style="margin-right: 6px"
          @click="checkOtherEmp"
        />
      </template>
    </van-nav-bar>
    <div class="overflow_div">
      <div class="face_box">
        <div class="btn_box">
          <van-button
            v-if="use_emppic"
            plain
            size="small"
            :class="activeImg == 3 ? 'activebtn' : ''"
            type="info"
            @click="activeImg = 3"
            >{{ $t('faceCollection.FcText8') }}</van-button
          >
          <van-button
            v-if="use_cappic1"
            plain
            size="small"
            :class="activeImg == 1 ? 'activebtn' : ''"
            type="info"
            @click="activeImg = 1"
            >{{ $t('faceCollection.FcText5') }}</van-button
          >
          <van-button
            v-if="use_cappic2"
            plain
            size="small"
            :class="activeImg == 2 ? 'activebtn' : ''"
            type="info"
            @click="activeImg = 2"
            >{{ $t('faceCollection.FcText6') }}</van-button
          >
        </div>
        <div class="images_box">
          <template v-if="use_cappic1 && activeImg == 1">
            <div v-if="loading1" class="loading">
              <van-loading type="spinner" color="#1989fa" />
            </div>
            <van-image v-else fit="contain" :src="pic1" />
          </template>
          <template v-if="use_cappic2 && activeImg == 2">
            <div v-if="loading2" class="loading">
              <van-loading type="spinner" color="#1989fa" />
            </div>
            <van-image v-else fit="contain" :src="pic2" />
          </template>
          <template v-if="use_emppic && activeImg == 3">
            <div v-if="loading3" class="loading">
              <van-loading type="spinner" color="#1989fa" />
            </div>
            <van-image v-else fit="contain" :src="pic3" />
          </template>
        </div>
        <div
          class="upload_box"
          v-if="
            $t('faceCollection.FcText5') ||
              $t('faceCollection.FcText6') ||
              $t('faceCollection.FcText8')
          "
        >
          <div
            v-if="use_cappic1 && $t('faceCollection.FcText5') && activeImg == 1"
          >
            <van-uploader
              ref="uploader1"
              :accept="cap_select_from_photo == 2 ? '' : 'image/*'"
              :capture="capture"
              :webkitdirectory="cap_select_from_photo == 2"
              :max-count="1"
              :after-read="afterRead1"
              :before-read="beforeRead"
              style="display:none"
            >
            </van-uploader>
            <van-button
              size="small"
              :icon="require('@assets/img/face_pic.png')"
              type="info"
              style="width:125px"
              @click="getUpload(1)"
              >{{ $t('faceCollection.FcText5') }}</van-button
            >
          </div>
          <div
            v-if="use_cappic2 && $t('faceCollection.FcText6') && activeImg == 2"
          >
            <van-uploader
              ref="uploader2"
              :accept="cap_select_from_photo == 2 ? 'image/*, .zz' : 'image/*'"
              :capture="capture"
              :webkitdirectory="cap_select_from_photo == 2"
              :max-count="1"
              :after-read="afterRead2"
              :before-read="beforeRead"
              style="display:none"
            >
            </van-uploader>
            <van-button
              size="small"
              :icon="require('@assets/img/face_pic.png')"
              type="info"
              style="width:125px"
              @click="getUpload(2)"
              >{{ $t('faceCollection.FcText6') }}</van-button
            >
          </div>
          <div
            v-if="use_emppic && $t('faceCollection.FcText8') && activeImg == 3"
          >
            <van-uploader
              ref="uploader3"
              :accept="cap_select_from_photo == 2 ? 'image/*, .zz' : 'image/*'"
              :capture="capture"
              :max-count="1"
              :after-read="afterRead3"
              :before-read="beforeRead"
              style="display:none"
            >
            </van-uploader>
            <van-button
              size="small"
              :icon="require('@assets/img/face_pic.png')"
              type="info"
              style="width:125px"
              @click="getUpload(3)"
              >{{ $t('faceCollection.FcText8') }}</van-button
            >
          </div>
        </div>
        <div class="user_box">
          <div class="user1">
            <span>{{ $t('faceCollection.FcText2') }}</span>
            <span>{{ userData.empcode }}</span>
          </div>
          <div class="user2">
            <span>{{ $t('faceCollection.FcText3') }}</span>
            <span>{{ userData.empname }}</span>
          </div>
          <div class="user3">
            <span>{{ $t('faceCollection.FcText4') }}</span>
            <span>{{ userData.deptname }}</span>
          </div>
        </div>
      </div>
      <div class="description">
        <div class="title">{{ $t('faceCollection.FcText9') }}</div>
        <div class="pic_box">
          <div class="pic_item">
            <van-image
              fit="contain"
              :src="require('@assets/img/face_gather1.png')"
            />
            <div class="describe">
              <van-icon name="success" color="#00AE66" />
              <span>{{ $t('faceCollection.FcText10') }}</span>
            </div>
          </div>
          <div class="pic_item">
            <van-image
              fit="contain"
              :src="require('@assets/img/face_gather2.png')"
            />
            <div class="describe">
              <van-icon name="cross" color="#E50530" />
              <span>{{ $t('faceCollection.FcText11') }}</span>
            </div>
          </div>
          <div class="pic_item">
            <van-image
              fit="contain"
              :src="require('@assets/img/face_gather3.png')"
            />
            <div class="describe">
              <van-icon name="cross" color="#E50530" />
              <span>{{ $t('faceCollection.FcText12') }}</span>
            </div>
          </div>
          <div class="pic_item">
            <van-image
              fit="contain"
              :src="require('@assets/img/face_gather4.png')"
            />
            <div class="describe">
              <van-icon name="cross" color="#E50530" />
              <span>{{ $t('faceCollection.FcText13') }}</span>
            </div>
          </div>
        </div>
        <div class="desc">1、{{ $t('faceCollection.FcText14') }}</div>
        <div class="desc">2、{{ $t('faceCollection.FcText15') }}</div>
        <div class="desc">3、{{ $t('faceCollection.FcText16') }}</div>
        <div class="desc">4、{{ $t('faceCollection.FcText17') }}</div>
        <div class="desc">5、{{ $t('faceCollection.FcText18') }}</div>
        <div class="img_box">
          <div class="oneimg">
            <van-image
              fit="contain"
              :src="require('@assets/img/face_gather5.png')"
            />
          </div>
          <div class="oneimg">
            <van-image
              fit="contain"
              :src="require('@assets/img/face_gather6.png')"
            />
          </div>
          <div class="oneimg">
            <van-image
              fit="contain"
              :src="require('@assets/img/face_gather7.png')"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- 选择人员树弹窗 -->
    <PopTree
      ref="popTreeNode"
      :whichTree="'employee'"
      module="201"
      :multiseltree="false"
      @treeSelectValEvent="treeSelectValEvent"
    ></PopTree>

    <!-- 新增派工弹窗 #ff976a -->
    <van-dialog
      v-model="showWarnMsgDia"
      :title="warnMsgDiaTitle"
      class="faceCollection_show_Warn_Msg"
      show-cancel-button
      :confirm-button-text="
        countdown > 0
          ? yes_btn_title + ('（' + countdown + 'S' + '）')
          : yes_btn_title
      "
      confirm-button-color="#0782F5"
      :cancel-button-text="no_btn_title"
      :beforeClose="closeWarnMsgDia"
    >
      <div class="warnMsgDia_content">
        <div class="warnMsg" :class="show_agree_select ? 'hasNextBox' : ''">
          {{ warnMsgDiaMessage }}
        </div>
        <div class="radio_box" v-if="show_agree_select">
          <van-checkbox v-model="agree_select">{{ radioTxt }}</van-checkbox>
        </div>
      </div>
    </van-dialog>
    <van-action-sheet
      v-model="showPicSelect"
      :actions="actions"
      @select="onSelect"
    />
    <camera ref="camera" @beforeRead="getCarFIle" />
  </div>
</template>

<script>
import { Toast, Dialog, Notify } from 'vant'
// import Compressor from 'compressorjs'
import * as imageConversion from 'image-conversion'
import {
  getEmpInfoByEmpCode,
  // upLoadFile,
  getCapPicPath,
  getEmpPicPath,
  getHrQueryPageInfo,
  upLoadBase64FileJson,
  getFaceCollectWarnInfo
} from '@api/wx.js'
import { getDownLoadFileName } from '@api/wxzp.js'
import { checkUserLogin } from '@api/login.js'
import { getOpenId } from '@/utils/auth'
import PopTree from '@components/PopTree/index.vue'
import camera from '@components/camera'
export default {
  components: {
    PopTree,
    camera
  },
  data() {
    const userInfo = localStorage.userInfo
      ? JSON.parse(localStorage.userInfo)
      : {}
    return {
      capture: null,
      uploadernum: 1,
      showPicSelect: false,
      actions: [
        { name: '人脸采集', select: 1 },
        { name: '默认相机', select: 2 },
        { name: '从相册选择', select: 3 }
      ],
      userInfo,
      empid: '',
      empcode: '',
      pic1: require('@assets/img/login.png'),
      pic2: require('@assets/img/login.png'),
      pic3: require('@assets/img/login.png'),
      userData: {},
      use_cappic1: 0,
      use_cappic2: 0,
      loading1: false,
      loading2: false,
      loading3: false,
      CapPicpath: 'CapPic',
      activeImg: 1,
      use_emppic: window.use_emppic || 0,
      cap_select_from_photo: window.cap_select_from_photo || 0,
      empPicPath: '',
      otherUserName: '',
      can_query_branch_record: false,
      ////////////////////////
      showWarnMsgDia: false,
      warnMsgDiaTitle: '',
      warnMsgDiaMessage: '',
      countdown: 0,
      no_btn_title: '取消',
      yes_btn_title: '确认',
      warnMsgDiaCansave: false,
      timer: null,
      radioTxt: '',
      agree_select: false,
      show_agree_select: false
    }
  },
  created() {
    this.use_cappic1 = window.use_cappic1 || 0
    this.use_cappic2 = window.use_cappic2 || 0
    this.use_emppic = window.use_emppic || 0
    this.cap_select_from_photo = window.cap_select_from_photo || 0
    this.activeImg = this.use_cappic1
      ? 1
      : this.use_cappic2
      ? 2
      : this.use_emppic
      ? 3
      : 1
    const o = window.use_face_frame?
    [{ name: '人脸采集', select: 1 }]:[]
    if (this.cap_select_from_photo == 0) {
      this.actions = [        
        { name: '默认相机', select: 2 },
        { name: '从相册选择', select: 3 }
      ]
    } else if (this.cap_select_from_photo == 1) {
      this.actions = [        
        { name: '默认相机', select: 2 }
      ]
    } else if (this.cap_select_from_photo == 2) {
      this.actions = [
        { name: '从相册选择', select: 3 }
      ]
    }
    this.actions =[...o,...this.actions]
    this.empid = this.userInfo.empid
    this.empcode = this.userInfo.empcode
    this._getCapPicPath()
    this._getEmpPicPath()
    // 触发一次登陆，保证单点登陆也有openid
    this.checkUserLogin()
    this.getHrQueryPageInfoData()

    this.getFaceCollectWarnInfo()
  },
  methods: {
    closeWarnMsgDia(action, done) {
      if (action == 'confirm') {
        if (
          (this.countdown == 0 && !this.show_agree_select) ||
          (this.show_agree_select && this.agree_select && this.countdown == 0)
        ) {
          done()
        } else {
          done(false)
        }
      } else {
        if (this.warnMsgDiaCansave) {
          this.onClickLeft()
        } else {
          done()
        }
      }
    },
    // 获取查询页面相关配置信息
    getHrQueryPageInfoData() {
      getHrQueryPageInfo({
        moduleno: 201,
        empcode: this.userInfo.empcode,
        langid: localStorage.getItem('langid')
      }).then(res => {
        let pageinfo = res.pageinfo[0]
        this.can_query_branch_record = pageinfo.can_query_branch_record
      })
    },
    // 杀人
    closeOtherEmp() {
      this.otherUserName = ''
      this.empid = this.userInfo.empid
      this.empcode = this.userInfo.empcode
      this._getCapPicPath()
      this._getEmpPicPath()
      // 触发一次登陆，保证单点登陆也有openid
      this.checkUserLogin()
    },
    // 选择人员弹窗回调
    treeSelectValEvent(data) {
      console.log(data, 'data')
      this.otherUserName = data.empname
      this.empid = data.empid
      this.empcode = data.empcode
      this._getCapPicPath()
      this._getEmpPicPath()
      // 触发一次登陆，保证单点登陆也有openid
      this.checkUserLogin()
    },
    // 选人
    checkOtherEmp() {
      this.$refs.popTreeNode.module = '201'
      this.$refs.popTreeNode.treename = 'emptree'
      this.$refs.popTreeNode.fieldname = 'cap_select_emplist'
      this.$refs.popTreeNode.editstate = 2
      this.$refs.popTreeNode.showEmpTreePop('员工')
    },
    checkUserLogin() {
      let hasOpenId = getOpenId()
      if (hasOpenId === '0') hasOpenId = ''
      checkUserLogin({
        username: this.userInfo.username,
        pwd: localStorage.getItem('v8_login_pwd'),
        langid: localStorage.getItem('langid') || 0,
        openid: hasOpenId || ''
      }).then(res => {
        if (res.iserror != '0') {
          Notify({
            type: 'danger',
            message: res.errormsg
          })
        }
      })
    },
    _getEmpPicPath() {
      getEmpPicPath().then(res => {
        this.empPicPath = res
        this.getZhengJianPic()
      })
    },
    _getCapPicPath() {
      getCapPicPath()
        .then(res => {
          this.CapPicpath = res
        })
        .finally(() => {
          // 获取用户信息
          this.getEmpInfoByEmpCodeData()
          this.getDownLoadFileNameData(5)
          this.getDownLoadFileNameData(6)
        })
    },
    onClickLeft() {
      // this.$router.back()
      if (this.$route.query.from == 'home') {
        this.$router.push('/home')
      } else {
        this.$router.push('/personCen')
      }
    },
    // 获取证件照
    getZhengJianPic() {
      getDownLoadFileName({
        dflag: 4,
        moduleno: 201,
        autoid: this.empid,
        filename: 'emp_' + this.empid,
        fileext: '.jpg',
        file_name_guid: '',
        downloadpath: this.empPicPath
      }).then(res => {
        this.pic3 = res + '?v=' + Date.parse(new Date()) + 120
      })
    },
    // 获取自拍照1和自拍照2的地址
    getDownLoadFileNameData(dflag) {
      getDownLoadFileName({
        dflag: dflag,
        moduleno: 201,
        autoid: this.empid,
        filename: 'CapPic',
        fileext: '.jpg',
        file_name_guid: '',
        downloadpath: this.CapPicpath
      }).then(res => {
        if (dflag == 5) {
          this.pic1 = res + '?v=' + Date.parse(new Date())
        } else if (dflag == 6) {
          this.pic2 = res + '?v=' + Date.parse(new Date()) + 60
        }
      })
    },
    getFaceCollectWarnInfo() {
      setTimeout(() => {
        getFaceCollectWarnInfo({
          username: this.userInfo.username
        }).then(res => {
          const arr = res.data
          for (let i = 0; i < arr.length; i++) {
            this.countdown = arr[i].countdown || 0
            this.timer = null
            this.timer = setInterval(() => {
              if (this.countdown > 0) {
                this.countdown--
              } else {
                clearInterval(this.timer)
              }
            }, 1000)
            this.warnMsgDiaTitle = arr[i].title || '系统提示'
            this.warnMsgDiaMessage = arr[i].info
              ? arr[i].info.replace(/<br>/g, '\n')
              : ''
            this.no_btn_title = arr[i].no_btn_title
            this.yes_btn_title = arr[i].yes_btn_title
            this.warnMsgDiaCansave = arr[i].cansave
            this.show_agree_select = arr[i].show_agree_select
            this.radioTxt = arr[i].agree_info

            if (arr[i].info && !arr[i].cansave) {
              if (arr[i].showbox) {
                this.showWarnMsgDia = true
              } else {
                Notify({
                  message: arr[i].info,
                  duration: 5000
                })
              }
              return
            } else if (arr[i].info && arr[i].cansave) {
              this.showWarnMsgDia = true
            }
            setTimeout(() => {
              // 因为标题可能会比较长，所以动态计算中间的高度
              const head = document
                .getElementsByClassName('faceCollection_show_Warn_Msg')[0]
                .querySelector('.van-dialog__header')
              const body = document
                .getElementsByClassName('faceCollection_show_Warn_Msg')[0]
                .querySelector('.van-dialog__content')
              const footer = document
                .getElementsByClassName('faceCollection_show_Warn_Msg')[0]
                .querySelector('.van-dialog__footer')
              const dateH = head.clientHeight + footer.clientHeight
              // console.log(dateH, 'dateHdateHdateH', body);
              body.style.height = 'calc(100% - ' + dateH + 'px)'
            }, 500)
          }
        })
      }, 500)
    },
    // 获取用户信息
    getEmpInfoByEmpCodeData() {
      getEmpInfoByEmpCode({
        empcode: this.empcode
      }).then(res => {
        this.userData = res.data[0]
      })
    },
    // 上传前处理
    beforeRead(file) {
      let _this = this
      // console.log(this.fileLists, "压缩前", file)
      if (Array.isArray(file)) {
        // 一定要异步和for of 否则批量压缩会出错
        return new Promise(async (resolve, reject) => {
          let arr = []
          let arr2 = []
          Toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true,
            message: '处理中...'
          })
          for (let item of file) {
            if (item.type.indexOf('image') != -1) {
              await imageConversion.compressAccurately(item, 500).then(res => {
                res = new File([res], item.name, {
                  type: res.type,
                  lastModified: Date.now()
                })
                // console.log("多图片上传，压缩后", res)
                arr.push(res)
              })
            } else {
              arr2.push(item)
            }
          }
          let arr3 = [...arr, ...arr2]
          Toast.clear()
          resolve(arr3)
        })
      } else {
        if (file.type.indexOf('image') != -1) {
          Toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true,
            message: '处理中...'
          })
          return new Promise((resolve, reject) => {
            imageConversion.compressAccurately(file, 500).then(res => {
              res = new File([res], file.name, {
                type: res.type,
                lastModified: Date.now()
              })
              // console.log(_this.fileLists, "单图片上传，压缩后", res)
              Toast.clear()
              resolve(res)
            })
          })
        } else {
          return new Promise((resolve, reject) => {
            resolve(file)
          })
        }
      }
    },
    onSelect(item) {
      this.showPicSelect = false
      if (item.select == 1) {
        // 打开摄像头和截图组件
        this.$refs.camera.ini()
      } else {
        this.capture = item.select == 3 ? null : 'camera'
        this.$forceUpdate()
        // this.openUpload(this.selPic)
        this.$nextTick(() => {
          if (this.uploadernum == 1) {
            this.$refs.uploader1.chooseFile()
          } else if (this.uploadernum == 2) {
            this.$refs.uploader2.chooseFile()
          } else if (this.uploadernum == 3) {
            this.$refs.uploader3.chooseFile()
          }
        })
      }
    },
    getCarFIle(file) {
      if (this.uploadernum == 1) {
        this.afterRead1(file)
      } else if (this.uploadernum == 2) {
        this.afterRead2(file)
      } else if (this.uploadernum == 3) {
        this.afterRead3(file)
      }
    },
    // 调起上传组件实例
    getUpload(val) {
      this.uploadernum = val
      if (val == 1) {
        if (this.pic1) {
          Dialog.confirm({
            title: this.$t('module.PromptMessage'),
            message: this.$t('faceCollection.FcText19'),
            confirmButtonText: this.$t('module.confirm'),
            cancelButtonText: this.$t('module.cancel')
          })
            .then(() => {
              this.showPicSelect = true
              // this.$refs.uploader1.chooseFile()
            })
            .catch(() => {})
        } else {
          this.showPicSelect = true
          // this.$refs.uploader1.chooseFile()
        }
      } else if (val == 2) {
        if (this.pic2) {
          Dialog.confirm({
            title: this.$t('module.PromptMessage'),
            message: this.$t('faceCollection.FcText19'),
            confirmButtonText: this.$t('module.confirm'),
            cancelButtonText: this.$t('module.cancel')
          })
            .then(() => {
              // this.$refs.uploader2.chooseFile()
              this.showPicSelect = true
            })
            .catch(() => {})
        } else {
          this.showPicSelect = true
          // this.$refs.uploader2.chooseFile()
        }
      } else if (val == 3) {
        if (this.pic3) {
          Dialog.confirm({
            title: this.$t('module.PromptMessage'),
            message: this.$t('faceCollection.FcText19'),
            confirmButtonText: this.$t('module.confirm'),
            cancelButtonText: this.$t('module.cancel')
          })
            .then(() => {
              this.showPicSelect = true
              // this.$refs.uploader3.chooseFile()
            })
            .catch(() => {})
        } else {
          this.showPicSelect = true
          // this.$refs.uploader3.chooseFile()
        }
      }
    },
    // 拍照1上传
    async afterRead1(file) {
      this.loading1 = true
      const base64s = file.content
      // let realFile = file.file
      // let newFile = await this.reFileName('image/jpg', realFile, 'CapPic.jpg')
      // let n = newFile.type.indexOf("/");
      // let fileext = newFile.type.slice((n + 1));
      // let fileName = newFile.name;
      let params = {
        filebase64str: base64s,
        upflag: 5,
        moduleno: 201,
        autoid: this.empid,
        uploadpath: this.CapPicpath,
        fileext: 'jpg',
        username: this.userInfo.username,
        packagetype: ''
      }
      upLoadBase64FileJson(params).then(res => {
        this.loading1 = false
        if (res == 'OK') {
          // this.pic1 = base64s
          this.getDownLoadFileNameData(5)
          Toast.success(this.$t('faceCollection.FcText7'))
        } else {
          Dialog.alert({
            message: res
          }).then(() => {
            // on close
          })
        }
      })
    },
    // 拍照2上传
    async afterRead2(file) {
      this.loading2 = true
      const base64s = file.content
      // let realFile = file.file
      // let newFile = await this.reFileName('image/jpg', realFile, 'CapPic.jpg')
      // let n = newFile.type.indexOf("/");
      // let fileext = newFile.type.slice((n + 1));
      // let fileName = newFile.name;
      let params = {
        filebase64str: base64s,
        upflag: 6,
        moduleno: 201,
        autoid: this.empid,
        uploadpath: this.CapPicpath,
        fileext: 'jpg',
        username: this.userInfo.username,
        packagetype: ''
      }
      upLoadBase64FileJson(params).then(res => {
        this.loading2 = false
        if (res == 'OK') {
          // this.pic2 = base64s
          this.getDownLoadFileNameData(6)
          Toast.success(this.$t('faceCollection.FcText7'))
        } else {
          Dialog.alert({
            message: res
          }).then(() => {
            // on close
          })
        }
      })
    },
    // 证件照上传
    async afterRead3(file) {
      this.loading3 = true
      const base64s = file.content
      // let realFile = file.file
      // let newFile = await this.reFileName('image/jpg', realFile, 'emp_' + this.empid + '.jpg')
      // let n = newFile.type.indexOf("/");
      // let fileext = newFile.type.slice((n + 1));
      // let fileName = newFile.name;
      let params = {
        filebase64str: base64s,
        upflag: 4,
        moduleno: 201,
        autoid: this.empid,
        uploadpath: this.empPicPath,
        fileext: 'jpg',
        username: this.userInfo.username,
        packagetype: ''
      }
      upLoadBase64FileJson(params).then(res => {
        this.loading3 = false
        if (res == 'OK') {
          // this.pic3 = base64s
          Toast.success(this.$t('faceCollection.FcText7'))
          this.getZhengJianPic()
        } else {
          Dialog.alert({
            message: res
          }).then(() => {
            // on close
          })
        }
      })
    },
    // 压缩图片
    compressorImage(file) {
      return new Promise((resolve, reject) => {
        imageConversion.compressAccurately(file, 500).then(res => {
          res = new File([res], file.name, {
            type: res.type,
            lastModified: Date.now()
          })
          resolve(res)
        })
      })
    },
    // 重命名file
    async reFileName(type, file, name) {
      const tempFile = file
      const size = tempFile.size
      let uploadFile = new File([tempFile], name, { type, size })
      return uploadFile
      //调用文件上传接口上传文件
    }
  }
}
</script>

<style scoped lang="less">
.faceCollection_show_Warn_Msg {
  height: 80%;
  /deep/.van-dialog__header {
    padding: 20px 0;
    background-image: url('~@/assets/img/job_booking09.png');
    background-repeat: no-repeat;
    background-size: 100%;
    color: #08306b;
    // .title {
    font-size: 32px;
    font-weight: bold;
    // margin-bottom: 10px;
    // }
  }
  /deep/.van-dialog__content {
    height: calc(100% - 190px);
    .warnMsgDia_content {
      height: 100%;
      padding: 20px;
      .warnMsg {
        height: 100%;
        overflow-y: auto;
        font-size: 28px;
        white-space: pre-wrap;
      }
      .hasNextBox {
        height: calc(100% - 145px);
      }
      .radio_box {
        padding-top: 20px;
        border-top: 1px solid #ebedf0;
        height: 145px;
        overflow-y: auto;
        font-size: 24px;
      }
    }
  }
  /deep/.van-dialog__footer {
    border-top: 1px solid #ebedf0;
  }
}

.faceCollection {
  height: 100vh;
  overflow: hidden;
  // background: #eceaea;
  .van-hairline--bottom::after {
    border-bottom-width: 0;
  }
  .van-nav-bar {
    background: #2b8df0;
    /deep/ .van-nav-bar__left {
      .van-icon {
        color: #fff;
      }
    }
    /deep/.van-nav-bar__title {
      color: #fff;
      font-size: 36px;
      font-family: Source Han Sans CN;
    }
    ::v-deep .van-nav-bar__right {
      .van-tag {
        margin-right: 24px;
        font-size: 24px;
        .van-icon {
          color: #ffffff;
        }
      }
      .van-nav-bar__text {
        color: #fff;
        font-family: Source Han Sans CN;
      }
    }
  }
  .overflow_div {
    overflow: auto;
    height: calc(100% - 100px);
    .face_box {
      margin: 20px;
      padding: 20px;
      background: #ffffff;
      box-shadow: 0px 3px 6px 1px rgba(82, 155, 178, 0.16);
      border-radius: 16px;
      .btn_box {
        display: flex;
        justify-content: space-evenly;
        .van-button {
          border-radius: 8px;
          padding: 0 30px;
        }
        .activebtn {
          background: #bfdcfb;
        }
      }
      .images_box {
        margin-top: 60px;
        margin-bottom: 40px;
        display: flex;
        justify-content: space-around;
        .loading {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40%;
        }
        .van-image {
          // width: 40%;
          width: 400px;
          height: 400px;
          /deep/ img {
            box-shadow: 0 0 60px rgba(43, 141, 240, 0.3);
            border-radius: 50%;
          }
        }
      }
      .upload_box {
        display: flex;
        justify-content: space-around;
        .van-uploader {
          width: 40%;
          /deep/.van-uploader__wrapper {
            .van-uploader__input-wrapper {
              width: 100%;
              .van-button {
                width: 100%;
              }
            }
          }
        }
      }
      .user_box {
        padding-top: 40px;
        padding-left: 20px;
        font-size: 28px;
        color: #666666;
        .user1,
        .user2 {
          margin-bottom: 10px;
        }
        .user3 {
          width: 50%;
        }
      }
    }

    .description {
      margin: 20px;
      padding: 20px;
      background: #ffffff;
      box-shadow: 0px 3px 6px 1px rgba(82, 155, 178, 0.16);
      border-radius: 16px;
      .title {
        font-size: 32px;
        margin-bottom: 20px;
      }
      .pic_box {
        display: flex;
        justify-content: space-between;
        margin-bottom: 40px;
        .pic_item {
          width: 24%;
          text-align: center;
          .describe {
            display: flex;
            align-items: center;
            justify-content: center;
            .van-icon {
              font-size: 24px;
            }
            font-size: 24px;
            color: #999999;
          }
        }
      }
      .desc {
        padding-left: 20px;
        margin-bottom: 10px;
        color: #999999;
        font-size: 24px;
      }
      .img_box {
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
        .oneimg {
          width: 30%;
        }
      }
    }
  }
}
</style>
